// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","5336": "5083bc5218c4","5379": "4fc1708e0049","9481": "3f1059c294bb",}[chunkId] + ".css"
}